import { render, staticRenderFns } from "./SupplierTop5.vue?vue&type=template&id=35fd7366&"
import script from "./SupplierTop5.vue?vue&type=script&lang=js&"
export * from "./SupplierTop5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports